import { Component } from 'react';

class DateTimeTools extends Component {
  static getFormatedTimeFromString(time) {
    if (time == null) {
      return '';
    }

    return time.split(' ')[0];
  }
}

export default DateTimeTools;
